import React from 'react';
import NavBar from '../components/NavBar';
import '../styles/sitePages.css';
import './About.css';
import { Helmet } from 'react-helmet-async';

function About() {
  return (
    <div>
      <Helmet>
        <title>About Logic Puzzles - Passionate Puzzle Game Developers</title>
        <meta name="description" content="Meet the team behind Logic Puzzles.ca! We're passionate software engineers and puzzle enthusiasts creating engaging brain-teasing games. Learn about our mission to develop challenging logic puzzles for all skill levels." />
        <link rel="canonical" href="https://logicpuzzles.ca/about" />
        <meta property="og:title" content="About Logic Puzzles - Passionate Puzzle Game Developers" />
        <meta property="og:description" content="Meet the team behind Logic Puzzles.ca! Passionate software engineers creating engaging brain-teasing games." />
        <meta property="og:url" content="https://logicpuzzles.ca/about" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://logicpuzzles.ca/og-image.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Logic Puzzles - Passionate Puzzle Game Developers" />
        <meta name="twitter:description" content="Meet the team behind Logic Puzzles.ca! Passionate software engineers creating engaging brain-teasing games." />
        <meta name="twitter:image" content="https://logicpuzzles.ca/og-image.png" />
      </Helmet>
      <NavBar />
      <div className="about-page">
        <header className="sp-hero">
          <div className="container">
            <span className="eyebrow">Spark &amp; Spiral · Made in Canada</span>
            <h1>About Us</h1>
          </div>
        </header>

        <div className="container sp-main">
          <section className="about-section about-story">
            <h2>Our Story</h2>
            <div className="about-story__body">
              <p>
                Welcome to Logic Puzzles.ca! We are a passionate team of software engineers and puzzle enthusiasts
                dedicated to creating engaging, mind-bending puzzles that challenge and delight players of all skill levels.
              </p>
              <p>
                Our journey began with a simple idea: to combine our love for programming with our fascination for logic puzzles.
                We believe that puzzles should be both challenging and accessible, featuring clean, intuitive user interfaces
                that let players focus on solving the puzzle rather than fighting with controls.
              </p>
            </div>
          </section>

          <section className="about-section about-founder">
            <div className="about-founder__mark">
              <img src="/team/ben-miller.webp" alt="Ben Miller" width="132" height="132" loading="lazy" />
            </div>
            <div>
              <h2>Meet the Founder</h2>
              <p>
                <strong>Ben Miller</strong> is the founder and lead developer behind Logic Puzzles.ca. With over a decade of experience
                in software engineering, Ben combines technical expertise with a lifelong passion for puzzle design to create
                games that are both intellectually satisfying and beautifully crafted.
              </p>
              <p>
                Ben's background spans mobile app development, web technologies, and game design. His puzzle apps have been
                downloaded over 200,000 times, and Crowns holds a 4.8-star average from more than 4,200 App Store ratings.
                When not coding or solving puzzles, Ben enjoys exploring new puzzle mechanics and engaging with the
                Logic Puzzles community.
              </p>
              <p>
                <a className="about-founder__link" href="https://www.linkedin.com/in/benmiller12/" target="_blank" rel="noopener noreferrer">
                  Connect with Ben
                </a>
              </p>
            </div>
          </section>

          <div className="about-pillars">
            <section className="about-section about-pillar">
              <h2>Our Mission</h2>
              <p>
                We strive to create puzzle games that are not just entertaining but also help develop critical thinking
                and problem-solving skills. Each puzzle is carefully crafted to provide the perfect balance of challenge
                and satisfaction, ensuring endless hours of fun and mental stimulation.
              </p>
            </section>

            <section className="about-section about-pillar">
              <h2>Our Games</h2>
              <p>
                From the symmetrical challenges of Symmetrix to the fluid puzzles of Aquarium, each of our games offers
                a unique take on traditional logic puzzles. We're constantly working on new ideas and improvements,
                driven by our community's feedback and our own passion for puzzle innovation.
              </p>
            </section>

            <section className="about-section about-pillar">
              <h2>Join Our Community</h2>
              <p>
                We believe in building a community of puzzle enthusiasts who share our passion for logical challenges.
                Whether you're a casual player or a puzzle master, we invite you to join us on this exciting journey
                of discovery and mental challenge.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About; 